import Vue from 'vue'
import Vuex from 'vuex'
import {functions} from '@/FirebaseConfig'
Vue.use(Vuex)
export default {
    namespaced:true,
    state:{
      mensaje: {
        título: '',
        asunto: '',
        cuerpo: '',
      },
    },
    actions: {
      enviar_correo_a_todos:  ({state, rootState, commit})=>{
        return new Promise(async(resolve, rejected)=>{
          try {
            commit('Ayudas/cargando', true, {root: true})
            const _enviar_correo = functions.httpsCallable('correo_electronico-enviar_correo_electronico') 
            const configuracion_de_correo = rootState.CMS.contenido.configuracion_de_correo
            const correos = rootState.CMS.contenido.correos
            await Promise.all(correos.map(({correo})=>_enviar_correo({
                    correo_electronico: correo,
                    titulo: state.mensaje.título,
                    asunto: state.mensaje.asunto,
                    cuerpo: state.mensaje.cuerpo,
                    configuracion_de_correo
                })
            ))
            commit('Ayudas/cargando', false, {root: true})
            commit('Ayudas/launchSnackbar', 'Se ha enviado el mensaje a todos los registrados', {root: true})
            resolve()
          } catch (error) {
            rejected(error)
          }
        })
      },
      enviar_correo:  ({state, rootState, commit}, correo)=>{
        return new Promise(async(resolve, rejected)=>{
          try {
            commit('Ayudas/cargando', true, {root: true})
            const _enviar_correo = functions.httpsCallable('correo_electronico-enviar_correo_electronico') 
            const configuracion_de_correo = rootState.CMS.contenido.configuracion_de_correo
            await _enviar_correo({
              correo_electronico: correo,
              cuerpo: state.mensaje.cuerpo,
              titulo: state.mensaje.título,
              asunto: state.mensaje.asunto,
              configuracion_de_correo
            })
            commit('Ayudas/cargando', false, {root: true})
            commit('Ayudas/launchSnackbar', `Se han enviado el correo a: ${correo}`, {root: true})
            resolve()
          } catch (error) {
            rejected(error)
          }
        })
      },
    },
    mutations: {
      limpiar_mensaje: (state)=>{
        state.mensaje = {
          título: '',
          cuerpo: '',
          asunto: '',
        }
      },
    },
}
